var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmp = function SvgEmp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 21,
    viewBox: "0 0 82 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.773 20.101h13.743l-1.68-4.036H9.349l-2.327-4.123h9.263l-.948-2.3H6.42L9.176 5.39h8.143l2.37-3.992H5.644L0 10.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.787 20.101h6.485L23.759 9.575l1.27-2.262 5.433 12.745h6.572l5.302-12.789v12.832h6.44V1.397H38.48l-4.732 11.31-4.907-11.31h-6.747l-4.82 8.352zM50.388 1.397h16.407l-3.572 10.638h-7.234v5.537l-5.513 2.53-.088-18.705zm5.57 7.376h1.76l1.522-4.594h-3.282v4.594zM81.224 6.689a6.563 6.563 0 1 1-13.126 0 6.563 6.563 0 1 1 13.126 0zm-8.54 5.172l4.144.022v-.958h.448V9.478h.538V2.974h-1.098v3.987h-.38v-.445h-1.008v-.602h-1.479v1.07h-.537V2.038h-.986v6.303h-.605v-.89h-.47V9.01h.47v.846h.583v1.025l.38.006v.974z"
  }))));
};
export default SvgEmp;